var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('img', {
    staticClass: "layout-top-left",
    attrs: {
      "src": require("./images/momo_layout_top_left.png")
    }
  }), _c('img', {
    staticClass: "layout-bottom-left",
    attrs: {
      "src": require("./images/momo_layout_bottom_left.png")
    }
  }), _c('router-view')], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }